import React, { Component } from 'react'
import { connect } from 'react-redux';
import './DialogReport.css';
import { changeInputValue, refreshEmailAddressList } from './DialogReportActions';
import { PublicDialogButton as ButtonAction } from './PublicDialog';
import { closeOverlay } from './OverlayActions'
import InputTextarea from './InputTextarea';
import InputBasic from './InputBasic';
import { summaryFromAgreementBlockchain, apiReportIssue } from "./ActionUtils";
import { DEFAULT_BUTTON_WIDTH } from './Constants.js';
import { getStatusMessageAndActions } from './AgreementMessageUtils';
import { track } from './ActionUtils';
import { openOverlay } from './OverlayActions';
import { shared } from '../Shared';

class DialogReport extends Component {

  constructor(props, context) {
    super(props)

    // This binding is necessary to make `this` work in the callback
    this.handleCancel = this.handleCancel.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.changeInputValue = this.changeInputValue.bind(this);
    this.handleDebug = this.handleDebug.bind(this);
  }

  componentDidMount() {
    this.props.dispatch(refreshEmailAddressList());
  }

  handleCancel(name, value) {
    this.props.dispatch(closeOverlay());
  }

  handleSubmit(name, value) {
    this.props.dispatch(changeInputValue("submitDisabled", true));
    this.props.dispatch(track("action", "button", JSON.stringify({type:"submit_feedback", dialog: "report"})));

    let auth = this.props.auth;

    let { agreementid="", mode="" } = this.props.agreement;
    let blockchainDataObj = summaryFromAgreementBlockchain(this.props.agreement);

    let { 
      statusActions, 
      statusDesc, 
      selectedStep
    } = getStatusMessageAndActions(mode, this.props.agreement, blockchainDataObj, null, null, this.props.dispatch);

    let { selectedPage="", fullPath="" } = this.props.menu;

    let { errorList=[] } = this.props.error;

    let reportObj = {
      authObj: this.props.auth,
      agreementDataObj: this.props.agreement,
      blockchainDataObj: blockchainDataObj,
      messageDataObj: { 
        statusActions, 
        statusDesc, 
        selectedStep,
        errorList
      },
      pathDataObj : {
        selectedPage,
        fullPath
      },
      errorObj: this.props.error
    };

    let data = JSON.stringify(reportObj);
    console.log("Submitting feedback with this data:");
    console.log(reportObj);

    let emailInput = this.props.dialogReport.issueEmail;
    let text = this.props.dialogReport.issueDetails + (emailInput !== "" ? ("\n\nemail: " + emailInput) : "");

    apiReportIssue(auth.uuid, auth.username, agreementid, data, text).then((success) => {
      if (success) {
        this.props.dispatch(changeInputValue("isSubmitted", true));
      }
      else {
        alert("Failed to submit");
      }
      this.props.dispatch(changeInputValue("submitDisabled", false));
    });
  }

  changeInputValue(name, value) {
    this.props.dispatch(changeInputValue(name, value));
  }

  handleDebug(name, value) {
    this.props.dispatch(openOverlay("debug", {}));
  }
  
  render() {
    let { agreementid="", title="" } = this.props.agreement;
    let { selectedPage="" } = this.props.menu;

    let isSubmitted = this.props.dialogReport.isSubmitted;

    let emailAddressFieldValue = this.props.dialogReport.issueEmail;

    let submitDisabled = this.props.dialogReport.submitDisabled;

    let maxContactLength = shared.MAX_IDENTIFIER_LENGTH;
    // We embed the contact info in the report text, so need to make room for it.
    let maxTextLength = shared.MAX_REPORT_TEXT_LENGTH - maxContactLength - 50; 
    let hasAgreementContext = agreementid !== "" && agreementid !== null && (selectedPage === "view" || selectedPage === "edit");

    return (
      <div className="publicDialogContent reportDialog">
        <header className="publicDialogHeader"><h2 id="public-dialog-title">Contact us</h2></header>
        <div className="publicDialogBody">
          {isSubmitted ? (
            <div>
              <div className="reportSuccess" role="status">Feedback submission successful. If you provided an email address we’ll get back to you soon.</div>
              <div className="reportActions">
                <ButtonAction name="done" minWidth={DEFAULT_BUTTON_WIDTH} text="Done" onClick={this.handleCancel}/>
              </div>
            </div>
          ) : (
            <div>
              <p className="reportIntro">Share feedback, report an issue, or ask a question. Data on the current page{hasAgreementContext && <React.Fragment> <strong>{title}</strong></React.Fragment>} will also be shared.</p>
              <InputTextarea maxlength={maxTextLength} aria-label="Enter feedback or question" placeholder="Enter feedback or question" className="textAreaInput reportMessage" name="issueDetails" value={this.props.dialogReport.issueDetails} onChange={this.changeInputValue} />
              <label className="reportContactLabel" htmlFor="report-contact">Contact info</label>
              <InputBasic id="report-contact" maxlength={maxContactLength} placeholder="Enter email address or other contact info" type="text" className="reportContactInput" name="issueEmail" value={emailAddressFieldValue} onChange={this.changeInputValue} />
              <div className="reportFooter">
                <button type="button" className="publicDialogTextButton reportDebug" onClick={this.handleDebug}>Debug info</button>
                <div className="reportActions">
                  <ButtonAction name="cancel" minWidth={DEFAULT_BUTTON_WIDTH} text="Cancel" onClick={this.handleCancel}/>
                  <ButtonAction name="submit" disabled={submitDisabled} minWidth={DEFAULT_BUTTON_WIDTH} text="Submit" onClick={submitDisabled ? null : this.handleSubmit}/>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    auth: state.auth,
    menu: state.menu,
    agreement: state.agreement,
    error: state.error,
    dialogReport: state.dialogReport
  }
}

const DialogReportContainer = connect(mapStateToProps, null)(DialogReport);
export default DialogReportContainer;
